import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './styles.css';
import { Well } from 'react-bootstrap';
import GrayPanel from '../../components/GrayPanel/GrayPanel';

class ConfirmDelete extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: this.props.userData,
      token: this.props.token,
      status: 'pending',
    };
  }

  componentDidMount = () => {
    const url = `${process.env.API_URL}/user/delete_account`;
    // const url = `http://localhost:8000/api/v1.0/user/delete_account`;

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token: this.state.token,
      }),
    })
    .then(async r => {
      const data = await r.json();

      let activationStatus = 'pending';

      if (r.status === 200) {
        activationStatus = 'success';

      } else if (r.status === 400) {

        switch (data.code) {

          case 'MISSING_TOKEN':
            activationStatus = 'missing';
            break;

          case 'INVALID_TOKEN':
            activationStatus = 'invalid';
            break;

          case 'ACCOUNT_ALREADY_DELETED':
            activationStatus = 'alreadyDeleted';
            break;

          default:
            activationStatus = 'error';
        }

      } else if (r.status === 404) {

        activationStatus = 'userNotFound';

      } else {

        activationStatus = 'error';
      }

      this.setState({
        status: activationStatus,
      }, this.logout);
    })
    .catch(() => {
      this.setState({
        status: 'error',
      });
    });
  };

  logout = () => {
    if (this.state.status === 'success' && this.state.user) {
      setTimeout(() => {
        location.href = '/logout';
      }, 5000);
    }
  }

  getStatusMessage = (status) => {
    switch (status) {
      case 'pending':
        return 'Trwa usuwanie konta...';

      case 'success':
        return 'Konto zostało pomyślnie usunięte! Zostaniesz automatycznie wylogowany z portalu e-usług E-SPDP.';

      case 'missing':
        return 'Nie podano tokenu aktywacyjnego. Proszę użyć linku z wiadomości e-mail, która została wysłana po żądaniu usunięcia konta.';

      case 'invalid':
        return 'Podany token jest nieprawidłowy lub wygasł. Proszę użyć linku z wiadomości e-mail, która została wysłana po żądaniu usunięcia konta.';

      case 'alreadyDeleted':
        return 'Konto zostało już usunięte.';

      case 'userNotFound':
        return 'Nie znaleziono użytkownika związanego z tym tokenem. Proszę użyć linku z wiadomości e-mail, która została wysłana po żądaniu usunięcia konta.';

      case 'error':
        return 'Wystąpił błąd podczas usuwania konta. Proszę spróbować ponownie później.';

      default:
        return '';
    }
  };

  render() {
    return (
      <div>
        <div className={s.delContainer} style={{ display: 'block' }}>
          <h4 className={s.delTitle}>Portal e-usług E-SPDP - usuwanie konta</h4>
          <div style={{ textAlign: 'center', marginBottom: '20px', height: '50px' }}>
            {this.getStatusMessage(this.state.status)}
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(ConfirmDelete);



// WEBPACK FOOTER //
// src/routes/ConfirmDelete/index.js